export default {"src":"/_next/static/media/Group-25844.e501446c.svg","height":104,"width":104};